import { formTypes as types } from '../constants';
import produce, { enableES5 } from 'immer';
import { AppStateFields } from './types';

enableES5();
export const initialState: AppStateFields = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    bizType: '',
    bizName: '',
    mcc: '',
    ssn: '',
    backupWithholding: '',
    itin: '',
    isUSBusinessEntity: '',
    isUSCitizen: '',
    ein: '',
    businessNumber: '',
    mobileNumber: '',
    nonProfitRegistry: '',
    charityRegistrationNumber: '',
    businessRegistrationNumber: '',
    stakeholders: [],
    businessAddress: '',
    dob: '',
    homeAddress: '',
    pointOfSaleLocation: '',
    seasonalBusiness: '',
    averageTransaction: '',
    iZettleTurnoverPercentage: '',
    currentAnnualTurnover: '',
    expectedAnnualTurnover: '',
    isBusinessUpgrade: false,
    isMinimalAccountCreated: false,
    isConsumerUpgrade: false,
    isPhoneNumberVerified: false,
    step: 0,
    businessWebsite: '',
    businessWebsiteExists: null
};

export default produce((draft, action): AppStateFields => {
    switch (action.type) {
        case types.UPDATE_FIELD:
            draft[action.fieldName] = action.fieldValue;
            return draft;
        case types.UPDATE_FIELDS:
            Object.entries(action.payload).forEach(
                ([fieldName, fieldValue]) => {
                    draft[fieldName] = fieldValue;
                }
            );
            return draft;
        case types.UPDATE_ARRAY_FIELD:
            draft[action.fieldName].push(action.fieldValue);
            return draft;
        case types.CLEAR_FIELDS:
            return initialState;
        default:
            return draft;
    }
}, initialState);
